import React from 'react';
import { List, ListItem, ListItemIcon, Drawer, Box, IconButton, Tooltip } from '@mui/material';
import { Home, AccountCircle, Payment, VpnKey, Support, Logout } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';

const Sidebar = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await api.post('/auth/logout');
      localStorage.removeItem('token');
      navigate('/');
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
    }
  };

  const menuItems = [
    { text: 'Home', icon: <Home />, path: '/dashboard' },
    { text: 'Users', icon: <AccountCircle />, path: '/users' },
    { text: 'Payments', icon: <Payment />, path: '/payments' },
    { text: 'Register PIX', icon: <VpnKey />, path: '/pix' },
    { text: 'Support', icon: <Support />, path: '/support' },
    { text: 'Logout', icon: <Logout />, action: handleLogout },
  ];

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: 80,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: 80, boxSizing: 'border-box' },
      }}
    >
      <Box sx={{ overflow: 'auto', paddingTop: '20px' }}>
        <List>
          {menuItems.map((item) => (
            <Tooltip title={item.text} placement="right" key={item.text}>
              <ListItem 
                button 
                component={item.path ? Link : 'button'} 
                to={item.path || '#'}
                onClick={item.action}
              >
                <ListItemIcon>
                  <IconButton>
                    {item.icon}
                  </IconButton>
                </ListItemIcon>
              </ListItem>
            </Tooltip>
          ))}
        </List>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
